export default __webpack_public_path__ + "static/media/medway-logo-horizontal-azul.3808fe3d.svg";